import { useLayoutEffect } from 'react';
import { createAuthInterceptor } from '../api/authInterceptor';
import { useAuth } from './useAuth';

export const useApiAuth = () => {
  const { accessToken, renewToken, logout } = useAuth();

  // Use useLayoutEffect to ensure interceptor is set up synchronously before any renders
  useLayoutEffect(() => {
    const tokenProvider = {
      getAccessToken: () => accessToken || null,
      renewToken: async () => {
        try {
          await renewToken();
        } catch (error) {
          console.error('Token renewal failed:', error);
          throw error;
        }
      },
      logout,
    };

    const cleanup = createAuthInterceptor(tokenProvider);

    return cleanup;
  }, [accessToken, renewToken, logout]);
};